<template>
  <div class="comp">
    <div class="compContent">
      <div class="title">
        <div class="titleL" v-if="yaofangParams.tabIndex === 0">病例录药</div>
        <div class="titleL" v-if="yaofangParams.tabIndex === 1">
          疫苗驱虫录药
        </div>
        <div class="titleL" v-if="yaofangParams.tabIndex === 2">
          医疗服务录药
        </div>
        <div class="titleR">
          <el-button type="warning" plain size="small" @click="back"
            >返回</el-button
          >
        </div>
      </div>
      <div class="content">
        <div class="msg">
          <div class="msgItem">
            <div class="label">顾客名称:</div>
            <div class="value">
              {{ detail.memberName }}
            </div>
          </div>
          <div class="msgItem">
            <div class="label">宠物昵称:</div>
            <div class="value">
              {{ detail.petName }} ({{ detail.typeName }})
            </div>
          </div>
          <div class="msgItem">
            <div class="label">添加人:</div>
            <div class="value">
              {{ detail.createUserName }}
            </div>
          </div>
          <div class="msgItem">
            <div class="label">套餐名称:</div>
            <div class="value">
              <span v-if="yaofangParams.tabIndex === 0">--</span>
              <span v-if="yaofangParams.tabIndex === 1">{{
                detail.servicePackageName
              }}</span>
              <span v-if="yaofangParams.tabIndex === 2">{{
                detail.medicalServiceName
              }}</span>
            </div>
          </div>
          <div class="msgItem">
            <div class="label">实施计划:</div>
            <div class="value">
              <span v-if="yaofangParams.tabIndex === 0">--</span>
              <span v-if="yaofangParams.tabIndex === 1">{{
                detail.planName
              }}</span>
              <span v-if="yaofangParams.tabIndex === 2">--</span>
            </div>
          </div>
          <div class="msgItem">
            <div class="label">日期:</div>
            <div class="value">
              {{ $public.FTime(detail.createTime) }}
            </div>
          </div>
        </div>
        <div class="relation">
          <div class="relationTitLine">
            <div style="line-height: 40px">
              <span>商品列表</span>
              <span style="font-size: 14px; margin-left: 40px">共计：</span
              ><span
            >{{ total.count }}件</span
            >
            </div>
            <div>

              <el-button v-if="outCount < total.count"
                  style="width: 100px"
                  type="warning"
                  plain
                  @click="submit"
                  size="small"
              >全部出库</el-button
              >
              <el-button v-if="outCount >= total.count"
                         style="width: 100px"
                         type="warning"
                         plain
                         @click="submit"
                         size="small"
                         disabled="disabled"
              >已全部出库</el-button
              >
            </div>
          </div>
          <el-table
            :data="tableData"
            style="width: 100%"
            default-expand-all
            row-key="tableKey"
            :tree-props="{ children: 'goodsList', hasChildren: 'hasChildren' }"
          >
            <el-table-column label="名称" min-width="250">
              <template slot-scope="props">
               {{ props.row.goodsName }}
              </template>
            </el-table-column>
            <el-table-column label="数量" min-width="70">
              <template slot-scope="props">
                <div v-if="props.row.goodsList">{{ props.row.num }}</div>
              </template>
            </el-table-column>
            <el-table-column label="用量" min-width="140">
              <template slot-scope="props">
                <div v-if="props.row.goodsList">
                  {{ props.row.goodsDosage }}
                  <span>{{ props.row.outUnit }}</span>
                </div>

                <div v-if="!props.row.goodsList">
                  <el-input
                    :disabled="props.row.isOut"
                    v-model="props.row.goodsDosage"
                    @input="changeGoodsDosage(props.row)"
                    size="small"
                    clearable
                  >
                    <template slot="append" style="padding: 0">{{
                      props.row.outUnit
                    }}</template>
                  </el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="最大用量" min-width="80">
              <template slot-scope="props">
                <div v-if="!props.row.goodsList">{{ props.row.onlyTimes }}</div>
              </template>
            </el-table-column>
            <el-table-column label="规格" min-width="100">
              <template slot-scope="props">
                <div v-if="props.row.goodsList">{{ props.row.skuValue }}</div>
              </template>
            </el-table-column>
            <el-table-column label="价格" min-width="100">
              <template slot-scope="props">
                <div v-if="props.row.goodsList">{{ props.row.price }}</div>
              </template>
            </el-table-column>
            <el-table-column label="单位" min-width="80">
              <template slot-scope="props">
                <div v-if="props.row.goodsList">{{ props.row.unit }}</div>
              </template>
            </el-table-column>
            <el-table-column label="总金额" min-width="100">
              <template slot-scope="props">
                {{ props.row.totalMoney }}
              </template>
            </el-table-column>
            <el-table-column label="是否出库" min-width="80">
              <template slot-scope="props">
                <span :style="{
                    color: props.row.isOut ? 'green' : 'red',
                  }">
               {{ props.row.isOut ? '已出库':'未出库' }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="settlement">

      <div style="text-align: right;">
        <span>总计：</span
        ><span style="font-size: 16px;"
      >￥{{ total.money }}</span
      >
      </div>
    </div>

    <div v-if="curRow.skus">
      <dialogAllCode :row="curRow" @submit="curRow = ''"></dialogAllCode>
    </div>
  </div>
</template>
<script>
import del from "../../../../util/del.js";
import dialogAllCode from "../../../../components/dialog_allCode.vue";
export default {
  components: { dialogAllCode },
  data() {
    return {
      detail: {},
      tableData: [],
      total: {
        count: 0,
        money: 0,
      },
      outCount:0,
      scanningCodeInput: "",
      o: null,
      curRow: "",
    };
  },
  computed: {
    yaofangParams() {
      return this.$store.state.yiliaoxin.yaofangParams;
    },
  },
  mounted() {
    this.o = new del(); // 仅仅使用获取条码接口
    this.getDetail();
  },
  methods: {
    back() {
      this.$store.commit("yiliaoxin/remove_router");
      if (this.$store.state.yiliaoxin.router.length === 0) {
        this.yaofangParams.type = "list";
        this.$store.commit("yiliaoxin/set_yaofangParams", this.yaofangParams);
        this.$store.commit("yiliaoxin/set_curBusiness", "药房");
      }
    },
    // 保存
    submit() {

      let serviceId = "";
      if (this.yaofangParams.tabIndex === 0) {
        serviceId = this.yaofangParams.curRow.caseNumber;
        console.log(this.yaofangParams.curRow.caseNumber, "ididid");
      } else if (this.yaofangParams.tabIndex === 1) {
        serviceId = this.yaofangParams.curRow.planId;
      } else if (this.yaofangParams.tabIndex === 2) {
        serviceId = this.yaofangParams.curRow.id;
      }
      if (this.yaofangParams.tabIndex === 0) {
        let params = {
          caseNumber: serviceId
        };
        let loading = this.$loading();
        this.$http.get("/api/Case/CaseGoodOut", params).then((res) => {
          loading.close();
          if (res.code == 0) {
            this.$message({
              message: "录入成功",
              type: "success",
            });
            this.getDetail();
          }
        });
      } else if (this.yaofangParams.tabIndex === 1) {
        let params = {
          serviceId: serviceId
        };
        let loading = this.$loading();
        this.$http
          .get("/api/MedicalPackage/GoodsOut", params)
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              this.$message({
                message: "出库成功",
                type: "success",
              });
              this.getDetail();
            }
          });
      } else if (this.yaofangParams.tabIndex === 2) {
        let params = {
          serviceId: serviceId
        };
        let loading = this.$loading();
        this.$http
          .get("/api/MedicalService/GoodsOut", params)
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              this.$message({
                message: "出库成功",
                type: "success",
              });
              this.getDetail();
            }
          });
      }
    },
    see(row) {
      this.curRow = row;
    },

    getDetail() {
      this.tableData = [];
      this.total.count = 0;
      this.total.money = 0;
      if (this.yaofangParams.tabIndex === 0) {
        this.$http
          .get("/api/Case/Detail", {
            caseNumber: this.yaofangParams.curRow.caseNumber,
          })
          .then((res) => {
            if (res.code == 0) {
              this.detail = res.data;
              let inspectItem = [];
              for (let i = 0; i < res.data.inspectItem.length; i++) {
                if (res.data.inspectItem[i].goodsType !== 4) {
                  inspectItem.push(res.data.inspectItem[i]);
                }
              }
              let tableData = res.data.recipelItem.concat(inspectItem);
              let table2 = this.filterList(tableData);
              this.o.init(table2);
              this.tableData = this.o.arr;
              for (let i = 0; i < this.tableData.length; i++) {
                this.total.count = this.total.count + this.tableData[i].num;
                this.total.money = this.$public.jia(
                    this.total.money,this.tableData[i].totalMoney
                );
              }
            }
          });
      } else if (this.yaofangParams.tabIndex === 1) {
        this.$http
          .get("/api/MedicalPackage/Plan/Detail", {
            planId: this.yaofangParams.curRow.planId,
          })
          .then((res) => {
            if (res.code == 0) {
              this.detail = res.data;
              let tableData = res.data.planGoods || [];
              let table = [];
              for (let i = 0; i < tableData.length; i++) {
                if (tableData[i].goodsType === 1 && tableData[i].replaceType !== 1) {
                    table.push(tableData[i]);
                }
              }
              let table2 = this.filterList(table);
              this.o.init(table2);
              this.tableData = this.o.arr;
              for (let i = 0; i < this.tableData.length; i++) {
                this.total.count = this.total.count + this.tableData[i].num;
                this.total.money = this.$public.jia(
                    this.total.money,this.tableData[i].totalMoney
                );
              }
            }
          });
      } else if (this.yaofangParams.tabIndex === 2) {
        this.$http
          .get("/api/MedicalService/Detail", {
            id: this.yaofangParams.curRow.id,
          })
          .then((res) => {
            if (res.code == 0) {
              this.detail = res.data;
              let tableData = res.data.serviceGoods || [];
              let table = [];
              for (let i = 0; i < tableData.length; i++) {
                if (tableData[i].goodsType === 1 && tableData[i].replaceType !== 1) {
                    table.push(tableData[i]);
                }
              }
              let table2 = this.filterList(table);
              this.o.init(table2);
              this.tableData = this.o.arr;
              for (let i = 0; i < this.tableData.length; i++) {
                this.total.count = this.total.count + this.tableData[i].num;
                this.total.money = this.$public.jia(
                    this.total.money,this.tableData[i].totalMoney
                );
              }
            }
          });
      }
    },

    // 重组tableData
    filterList(tableData) {
      let table = [];
      for (let i = 0; i < tableData.length; i++) {
        let goods = tableData[i];
        if (goods.isPay === true) {
          // 只处理已支付的
          let one = {
            goodsItemsId: goods.itemsId, // 该接口需要
            checkGoods: "",
            goodsId: goods.goodsId,
            goodsName: goods.goodsName,
            goodsType: goods.goodsType,
            skus: goods.skus || goods.goodsId, // 规格 skus
            skuValue: goods.skuValue || "", // 规格 skuValue
            unit: goods.unit,
            outUnit: goods.outUnit,
            allowWholesale: goods.allowWholesale,
            originalPrice: goods.originalPrice,
            price: goods.price,
            num: goods.num,
            isPay: goods.isPay,
            activityId: "",
            activityName: "",
            totalMoney: goods.totalMoney,
            goodsUsage: goods.goodsUsage,
            goodsDosage: goods.goodsDosage,
            goodsList: [],
            remark: goods.remark,
            extendContent: goods.extendContent
              ? JSON.parse(goods.extendContent)
              : "",
            isOut: goods.isOut || false,
          };
          if(one.isOut)
          {
            this.outCount++;
          }
          one.tableKey = "tableKey_goods_one" + Math.random();
          one.checkGoods = JSON.parse(JSON.stringify(one));
          table.push(one);
        }
      }
      return table;
    },
  },
};
</script>
<style scoped lang="scss">
.comp {
  position: relative;
  height: 100%;
  padding-bottom: 68px;
  box-sizing: border-box;
  .compContent {
    height: 100%;
    background-color: #fff;
    border-radius: 12px;
    overflow: auto;
    .title {
      display: flex;
      height: 47px;
      line-height: 27px;
      border-bottom: 1px solid #f2f2f2;
      padding: 10px 18px;
      box-sizing: border-box;
      .titleL {
        width: 50%;
        font-size: 14px;
        font-weight: bold;
      }
      .titleR {
        width: 50%;
        text-align: right;
        .titleRText {
          display: inline-block;
          font-size: 14px;
          color: $mainColor;
          margin-left: 40px;
          cursor: pointer;
        }
      }
    }
    .content {
      height: calc(100% - 47px);
      overflow: auto;
      .msg {
        display: flex;
        flex-wrap: wrap;
        padding-top: 10px;
        .msgItem {
          width: 30%;
          display: flex;
          padding: 5px 10px;
          .label {
            font-size: 14px;
            color: $fontColor;
            width: 70px;
            text-align: right;
            line-height: 32px;
            margin-right: 4px;
          }
          .value {
            font-size: 14px;
            color: $fontColor;
            line-height: 32px;
          }
        }
      }
      .relation {
        padding: 10px 0 8px;
        height: calc(100% - 140px);
        box-sizing: border-box;
        .relationTitLine {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          color: $fontColor;
          padding: 0 18px 10px;
          font-weight: bold;
        }
        .goodsLine {
          background-color: #f3f6ff;
          border: 1px solid #e4e7f8;
          border-radius: 4px;
          .goodsLineTit {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            color: $fontColor;
            padding: 6px 16px;
            line-height: 32px;
          }
          ::v-deep .el-table tr {
            background-color: #f3f6ff;
            th {
              background-color: #f3f6ff;
              border-top: 1px solid #e0e2f1;
              border-bottom: 1px solid #e0e2f1;
            }
            td {
              border-bottom: 1px solid #e0e2f1;
            }
          }
        }
      }
    }
  }
  .settlement {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 56px;
    background-color: #fff;
    border-radius: 12px 12px 0 0;
    display: flex;
    padding: 12px 20px;
    box-sizing: border-box;
    .settlementL {
      width: 70%;
      font-size: 14px;
      line-height: 32px;
    }
    .settlementR {
      width: 30%;
      text-align: right;
      font-size: 14px;
      line-height: 32px;
      .text {
        color: $fontColor;
        font-size: 14px;
        padding: 0px 24px 0;
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
}
</style>
